import { render } from "./featuresItem1.vue?vue&type=template&id=41c2525c"
import script from "./featuresItem1.vue?vue&type=script&lang=js"
export * from "./featuresItem1.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src719114813/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__